<div class="wrapper">
  <app-header></app-header>

  <div class="main pt-1">
    <div class="overflow-scroll p-2 header">
      <div class="progress-container">
        <div class="progress-bar">
          <div
            *ngFor="let item of issueList"
            class="progress-fill"
            [style.width.%]="progress"
            [ngClass]="{ inactive: !item.answered }"
          ></div>
        </div>
        <div class="progress-segment">{{ progress | number: '1.0-0' }}%</div>
      </div>
      <h2 class="header-text">{{ translations['check_machine'] }}</h2>

      <div *ngFor="let item of issueList; let i = index">
        <div class="check-item">
          <div class="result-content">
            <div class="sub-content">
              <div
                class="status-indicator"
                *ngIf="!item.answered; else answeredTemplate"
              >
                <div class="circle"></div>
              </div>
              <ng-template #answeredTemplate>
                <div class="ticks"><i class="fas fa-check"></i></div>
              </ng-template>
              <div class="content-list">{{ getTranslatedTitle(item) }}</div>
            </div>

            <!-- Accordion icon -->
            <div
              *ngIf="
                item.detailsKey && getTranslatedDetails(item)?.trim() !== ''
              "
              class="accordion-icon"
              (click)="toggleAccordion(i)"
            >
              <i
                [ngClass]="
                  item.expanded ? 'fas fa-chevron-up' : 'fas fa-chevron-down'
                "
              ></i>
            </div>
          </div>

          <div
            class="accordion-content"
            *ngIf="item.expanded && item.detailsKey"
          >
            <p>{{ getTranslatedDetails(item) }}</p>

            <!-- Display multiple images if available -->
            <div class="img-list">
              <div
                class="p-1"
                *ngFor="let img of item.images; let imgIndex = index"
              >
                <img
                  [src]="img"
                  alt="{{ getTranslatedTitle(item) }}"
                  class="img-thumbnail"
                  (click)="openPopup(item.images, getTranslatedTitle(item))"
                />
              </div>
            </div>

            <!-- Display video if available -->
            <div *ngIf="item.video">
              <video controls>
                <source [src]="item.video" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>

          <div class="actions">
            <button
              class="ok-btn"
              [class.selectedOk]="item.status === 'ok'"
              [class.inactive]="item.status === 'issue'"
              (click)="answer(i, 'ok'); item.expanded = false"
            >
              <div *ngIf="item.status === 'ok'" class="tick">
                <i class="fas fa-check"></i>
              </div>
              <div>{{ translations['ok'] }}</div>
            </button>

            <button
              class="issue-btn"
              [class.selectedIssue]="item.status === 'issue'"
              [class.inactive]="item.status === 'ok'"
              (click)="answer(i, 'issue'); item.expanded = false"
            >
              <div *ngIf="item.status === 'issue'" class="tick-issue">
                <i class="fas fa-check"></i>
              </div>
              <div>{{ translations['issue'] }}</div>
            </button>
          </div>
        </div>
      </div>
      <div class="button-group">
        <button class="help-btn" (click)="resolved()">
          {{ translations['resolved'] }}
        </button>
        <button class="btn-blue-outline ms-1" (click)="needHelp()">
          <img class="chatIcon" src="assets/images/icon/chat.png" />
          <span> {{ translations['need_help'] }}</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Popup Container -->
  <app-pop-up
    [visible]="showPopup"
    [images]="popupImages"
    (closeEvent)="closePopup()"
  ></app-pop-up>
</div>
